<div class="filters" [formGroup]="form">
  <ng-container *ngFor="let filter of data; let i = index">
    <div *ngIf="!filter.isHide">
      <div class="filters_filter" *ngIf="filter.type === 'string'">
        <div class="input-container">
          <div class="input-container_label">{{ filter.filterName }}:</div>
          <input
            [formControlName]="filter.filterName"
            class="input-container_input input-container_input--thin"
          />
        </div>
      </div>
  
      <div class="filters_filter" *ngIf="filter.type === 'number'">
        <div class="input-container">
          <div class="input-container_label">{{ filter.filterName }}:</div>
          <input
            type="number"
            [formControlName]="filter.filterName"
            class="input-container_input input-container_input--thin"
          />
        </div>
      </div>      
      <div class="filters_filter" *ngIf="filter.type === 'datepicker'">
        <div class="input-container_label">{{ filter.filterName }}:</div>
        <!-- <mat-form-field appearance="fill" class="mat-date-picker mat-select-control">      -->
        <mat-form-field appearance="fill" class="w-100 filter-datepicker">
          <mat-date-range-input [formGroupName]="filter.filterName" [rangePicker]="picker">
            <input
              matStartDate
              formControlName="start"
              placeholder="Start date"
            />
            <input matEndDate formControlName="end" placeholder="End date" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div> 
      
      <div class="filters_filter" *ngIf="filter.type === 'select'">
        <div class="input-container">
          <div class="input-container_label">{{ filter.filterName }}:</div>
          <select
            class="input-container_input input-container_input--small w-100 filters_select"
            [formControlName]="filter.filterName"
          >
            <option value="null" selected disabled>Select</option>
            <option
              *ngFor="let option of filter.availableValues"
              [value]="option.id > -1 ? option.id : option.name"
            >
            {{ option.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="filters_filter" *ngIf="filter.type === 'rangePicker'">
        <div class="input-container">
          <div class="input-container_label">{{ filter.filterName }}:</div>
          <mat-form-field appearance="fill" class="w-100 filter-datepicker">
            <input matInput [matDatepicker]="picker" [formControlName]="filter.filterName" placeholder="Date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          </div>
      </div>
  
      <div class="filters_filter" *ngIf="filter.type === 'checkbox'">
        <div class="input-container">       
          <mat-checkbox
            class="font-weight-normal"
            [formControlName]="filter.filterName"
            >{{filter.filterName}}</mat-checkbox
          >
        </div>
      </div>
  <div class="filters_filter" *ngIf="filter.type === 'mat-autocomplete'">
    <div class="add-sku_form">
      <div class="input-container input-container--fullWidth">
        <label for="" class="input-container_label">Items</label>
        <input
          type="text"
          class="input-container_input  input-container_input--small w-100"
          formControlName="autocomplete"
          [matAutocomplete]="auto"
          (click)="setScroll()"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" class="poAutocomplete">
          <mat-option
            *ngFor="let option of filteredOptions$"
            [value]="option"
            class="mat-option-override"
          >
            <app-item-typeahead
              [name]="option.title"
              [sku]="option.sku"
              [id]="option.name"
              [image]="option.imageUrl"
            ></app-item-typeahead>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </div>
    </div>
  </ng-container>
  
  <div class="filters_footer">
    <app-button
     [buttonSize]="'nopadding'"
     [buttonStyle]="'text'"
      (click)="resetFilter()"
    >
    {{ form.contains('autocomplete') ? 'Clear' : 'Clear All Filters'}}
    </app-button>
    <app-button
      (click)="submit()"
      [buttonSize]="form.contains('autocomplete') ? 'action' : 'small'"
      [isDisabled]="form.invalid"
    >
      Apply
    </app-button>
  </div>
</div>
